<template>
  <div class="demos-page page-container">
    <section class="page-header">
      <h1>教育演示</h1>
      <p>可视化演示，直观理解原理</p>
    </section>

    <!-- 品牌浅色提示带 -->
    <section class="intro-band">
      <i class="el-icon-reading" />
      <p>精选可视化教学演示，新标签页全屏打开，交互操作不受站点布局限制。</p>
    </section>

    <section class="demo-section">
      <div class="media-section-header">
        <h2>全部演示</h2>
        <span>共 {{ demos.length }} 个</span>
      </div>
      <div class="media-grid">
        <article v-for="demo in demos" :key="demo.id" class="media-card" @click="openDemo(demo)">
          <div class="media-tile demo-tile"><i :class="demo.icon" /></div>
          <div class="media-body">
            <h3>{{ demo.name }}</h3>
            <p>{{ demo.description }}</p>
            <el-button type="primary" size="small" icon="el-icon-full-screen">打开演示</el-button>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { demos } from '../config/demos'

export default {
  name: 'DemosPage',
  data() {
    return { demos }
  },
  methods: {
    // 演示页是独立 HTML，新开标签页全屏展示，不受站点布局限制。
    openDemo(demo) {
      window.open(demo.url, '_blank')
    }
  }
}
</script>

<style scoped>
.demos-page { padding-top: 72px; padding-bottom: 80px; }

/* 演示封面：品牌浅色渐变（共用卡片结构见全局 media-* 类） */
.demo-tile { background: linear-gradient(135deg, var(--brand-soft) 0%, var(--surface-2) 100%); }

@media (max-width: 600px) {
  .demos-page { padding-top: 40px; padding-bottom: 56px; }
}
</style>
